module.exports = __webpack_public_path__ + "img/img-box-covid19-left.649162a6.png";